import { render, staticRenderFns } from "./twoPartyProductLayout.vue?vue&type=template&id=2eb9f088&"
import script from "./twoPartyProductLayout.vue?vue&type=script&lang=js&"
export * from "./twoPartyProductLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports